import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import MultiLineSelectField from 'components/formComponents/multiLineSelectField';
import { MdArrowForward } from 'react-icons/md';
import OrderApi from 'api/orders';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import StoresApi from 'api/stores';
import TransactionTable from './components/transactionTable';
import Card from 'components/card/Card';
import LockersApi from 'api/lockers';
import InputField from 'components/formComponents/inputField';
import { OrderSummaryAdvanceBook } from '../../customerSavingPlans/components/OrderSummaryAdvanceBook';

const Locker = () => {
  const toast = useToast();
  const toastIdRef = React.useRef();
  const [lockerData, setLockerData] = useState({});
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [stores, setStores] = useState([]);
  const [error, setError] = useState('');
  const [orderSummary, setOrdersummary] = useState();

  const id = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const storeOptions = stores.map((branch) => ({
    value: branch.id,
    titleLabel: `${branch.name} (${branch.store_code})`,
    // subLabel: branch.company_name,
    bodyLabel: `${branch.city} ${branch.state} ${branch.pincode}`,
  }));

  const GoToCustomerUser = (id) => {
    const url = `/admin/customeruser/${id}`;
    window.open(url, '_blank');
  };

  const fetchStores = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await StoresApi.List({
        sort: 'name:asc',
        itemsPerPage: 100,
      });
      setStores(response.data.data.list);
    } catch (error) {
      setError('Failed to fetch stores');
    }
    setLoading(false);
  };

  const FetchLockerData = async () => {
    try {
      setLoading(true);
      let response = await LockersApi.Details({ userId: id });
      response = response.data;
      console.log('response from Locker Details', response);
      setLoading(false);
      if (response.status_code === 200) {
        setLockerData(response?.data);
      } else {
        setLockerData({});
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchLockerData();
    fetchStores();
  }, []);

  const modalValidationSchema = Yup.object({
    withdrawalWeight: Yup.number()
      .typeError('Must be a valid number')
      .positive('Must be a positive number')
      .max(
        lockerData?.total_weight,
        `Enter a value less than or equal to ${parseFloat(lockerData?.total_weight).toFixed(3)}`
      )
      .test('is-decimal', 'Max 3 decimal places are allowed', (value) =>
        /^\d+(\.\d{1,3})?$/.test(value)
      )
      .required('Withdrawal weight is required'),
  });

  if (orderSummary) {
    console.log('This is order summary', orderSummary);
    return <OrderSummaryAdvanceBook orderSummary={orderSummary} />;
  }

  const redeemAtStore = async (values) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }

    console.log('Inside redeem', values);
    try {
      let response = await LockersApi.Redeemjewel({
        operationLocationId: lockerData?.operation?.id,
        userid: id,
        storeId: values.storeId,
        withdrawalWeight: values.withdrawalWeight
      });
      response = response.data;
      console.log(
        'response from Customer Saving Plan Close Account -',
        response
      );

      if (response.status_code === 200) {
        // setPlanData(response?.data);
        setOrdersummary(response?.data);
      } else {
        toastIdRef.current = toast({
          title: response.message,
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  return loading ? (
    <Center
      mt='10rem'
      width='100%'
    // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : (
    <Box mt='8rem'>
      <Flex
        direction='column'
        gap={8}>
        <Card
          display='flex'
          gap={8}>
          <Flex direction={{ base: 'column', md: 'row' }}>
            <Flex
              direction='column'
              width='50%'
              gap={8}>
              <Flex
                direction='column'
                gap={2}>
                <Text fontWeight='medium'>Operation Location</Text>
                <Text ml={2}>{lockerData?.operation?.name}</Text>
              </Flex>
              {/* <Flex
                direction='column'
                gap={2}>
                <Text fontWeight='medium'>Current Gold Value in INR</Text>
                <Text ml={2}>{lockerData?.current_amount}</Text>
              </Flex> */}
            </Flex>
            <Flex
              direction='column'
              gap={8}>
              <Flex
                direction='column'
                gap={2}>
                <Text fontWeight='medium'>Gold Weight in Grams</Text>
                <Text ml={2}>
                  {isNaN(parseFloat(lockerData?.total_weight)) ? 'N/A' : parseFloat(lockerData?.total_weight).toFixed(3)}
                </Text>
              </Flex>
              {lockerData?.hold_weight && (
                <Flex
                  direction='column'
                  gap={2}>
                  <Text fontWeight='medium'>Gold Weight on Hold in Grams</Text>
                  <Text ml={2}>
                    {isNaN(parseFloat(lockerData?.hold_weight)) ? 'N/A' : parseFloat(lockerData?.hold_weight).toFixed(3)}
                  </Text>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Card>

        <Flex
          mt={2}
          direction='column'
          gap={3}>
          <Flex justifyContent='space-between'>
            <Text
              fontSize='2xl'
              fontWeight='500'>
              Advance Book Ledger
            </Text>

            {lockerData?.total_weight > 0 && (
              <Button
                colorScheme='blue'
                mt={4}
                alignSelf='flex-end'
                onClick={onOpen}>
                Redeem At Store
              </Button>
            )}
          </Flex>

          {lockerData?.list?.length > 0 ? (
            <TransactionTable
              propFunct={FetchLockerData}
              ledger={lockerData?.list}
            />
          ) : (
            <Flex>
              <Text fontWeight='medium'>There are no transactions.</Text>
            </Flex>
          )}
        </Flex>
      </Flex>

      <Modal
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              <b> Redeem your plan at the Store </b>
            </Text>
            <Formik
              initialValues={{ storeId: '', withdrawalWeight: '' }}
              validationSchema={modalValidationSchema}
              onSubmit={redeemAtStore}>
              {({ setFieldValue }) => (
                <Form>
                  <Flex direction='column'>
                    <MultiLineSelectField
                      name='storeId'
                      label='Branch Name'
                      options={storeOptions}
                      required
                    // onChange={(value) => {
                    //   setFieldValue('storeId', value?.value);
                    // }}
                    />
                  </Flex>

                  <InputField
                    label='Withdrawal Weight in grams'
                    name='withdrawalWeight'
                    type='number'
                    placeholder={`Max allowed = ${parseFloat(lockerData?.total_weight).toFixed(3)}`}
                    required
                  // onChange={(value) => {
                  //   console.log("value?.value :: ", value)
                  //   setFieldValue('withdrawalWeight', value?.value);
                  // }}
                  />

                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'>
                      Submit
                    </Button>
                    <Button
                      variant='ghost'
                      onClick={onClose}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Locker;
